@if (container()) {
  <div class="border-bottom container-fluid mw-100 bg-light" xmlns="http://www.w3.org/1999/html">
    <div class="row px-3 py-2 gx-4 main-row">
      <div class="d-none col-auto d-md-flex align-items-center" [style.width.px]="selectionWidth">
        @if (selectable()) {
          <app-selection-checkbox
            [ngModel]="selected() ? checkboxSelectionState.selected : checkboxSelectionState.unselected"
            (ngModelChange)="selectionToggled.emit()"></app-selection-checkbox>
        }
      </div>
      <div class="col-auto px-0 d-flex align-items-center">
        <button #collapseButton type="button" class="btn p-2 rounded-circle action-btn-lg" (click)="collapsed.set(!collapsed())"
                [ngClass]="collapsible() ? '' : 'invisible'"
                data-bs-toggle="collapse" [attr.data-bs-target]="'#'+validSelector(container().containerNumber)"
                [attr.aria-controls]="validSelector(container().containerNumber)" aria-expanded="false">
          <span class="h1 m-0 align-top text-primary">
            <i class="fa-light fa-fw" [ngClass]="collapsed() ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
          </span>
        </button>
      </div>
      <div class="col col-xl-2 col-xxl-1 d-flex align-items-center flex-grow-1 flex-md-grow-0" [style.min-width.px]="210">
        <div class="h-100 w-0 d-flex flex-grow-1 flex-column align-items-stretch justify-content-center">
          <div class="d-flex w-100 align-items-stretch">
            <span class="text-info d-inline-block text-truncate mw-100 h2 text-info mb-0" [title]="container().containerNumber">
              <app-highlight [term]="term()" [result]="container().containerNumber" (textHighlighted)="onHighlightMatch()"></app-highlight>
            </span>
          </div>
          <div class="d-flex align-items-center">
            @if (container().overlanded) {
              <span class="fa fa-fw fa-light fa-balance-scale-right sub-text me-2" [style.line-height.rem]="1.25"></span>
              <span>Overlanded</span>
            } @else {
              <span class="fa fa-fw fa-light fa-arrow-down-to-line sub-text me-2" [style.line-height.rem]="1.25"></span>
              <span>Inbound</span>
            }
          </div>
        </div>
      </div>
      <div class="col col-lg-4 col-vlg-2 col-xl-3 d-none d-lg-flex flex-column align-items-stretch justify-content-center">
        <div class="col-12 d-flex align-items-center">
          <span class="sub-text me-2">
            <i class="fa fa-fw fa-light fa-xl" [ngClass]="consignmentUtils.getEquipmentIconCls(sizeType(), isEmpty())"></i>
          </span>
          <div class="d-inline-block text-truncate">
            <span>
              {{consignmentUtils.sizeTypeFormatter(sizeType())}}
            </span>
          </div>
        </div>
        @if (container().terminalDataSummary?.portOfLoading) {
          <div class="col-12 d-flex align-items-center">
          <span class="sub-text me-2">
            <i class="fa fa-light fa-truck-ramp-couch"></i>
          </span>
            <div class="d-inline-block text-truncate">
            <span>
              {{container().terminalDataSummary.portOfLoading.name}} – {{container().terminalDataSummary.portOfLoading.locationUnCode}}
            </span>
            </div>
          </div>
        } @else {
          <div class="col-12">
            <span>&nbsp;</span>
          </div>
        }
      </div>
      <div class="col col-xl-2 col-xxl-1 d-none d-vlg-flex flex-column align-items-stretch justify-content-center dropdown"
           [style.min-width.px]="200">
        <button class="btn btn-plain p-0 d-inline-block text-truncate mw-100 underline-tertiary link-underline-tertiary link-primary text-body text-start"
                [title]="container().crn" data-bs-toggle="dropdown">
          <app-highlight [term]="term()" [result]="container().crn" emptyText="unknown" (textHighlighted)="onHighlightMatch()"></app-highlight>
          <span class="ms-1 m-0 text-primary">
            <i class="fa-light fa-fw fa-chevron-down"></i>
          </span>
        </button>
        <ul class="dropdown-menu position-fixed" style="cursor: pointer">
          <a class="dropdown-item" [routerLink]="'/details/' + container().crn" target="_blank">
            <i class="fa-light fa-fw fa-arrow-up-right-from-square"></i>
            Open visit
          </a>
          <a class="dropdown-item" [routerLink]="'/container/' + container().crn">
            <i class="fa-light fa-fw fa-filter"></i>
            Filter overview by this CRN
          </a>
        </ul>
        <div class="d-inline-block text-truncate">
          @if (containerOperator()) {
            <span>{{ containerOperator() }}</span>
          } @else {
            <span>&nbsp;</span>
          }
        </div>
      </div>
      <div class="d-none d-xxl-block col-xxl-2">
        <div class="col-12 position-relative" [style.height.rem]="1.5">
          <div class="position-absolute d-flex align-items-center h-100 w-100 pe-2">
            <span class="me-2 text-truncate" style="min-width: 0">
              <app-highlight [term]="term()" [result]="terminal()" (textHighlighted)="onHighlightMatch()"></app-highlight>
            </span>
          </div>
        </div>
        @if (container().terminalDataSummary?.actualTimeOfHandling) {
          <span class="col-12 arrival-date" [ngClass]="(!!container().terminalDataSummary.actualTimeOfHandling ? '' : ' text-muted ')">
            <span>
              {{ (container().terminalDataSummary.actualTimeOfHandling | date:'dd MMM HH:mm')}}
            </span>
          </span>
        } @else {
          <span>&nbsp;</span>
        }
      </div>
      <div class="col-auto ms-auto d-flex flex-column align-items-stretch justify-content-center" [style.width.px]="200">
        <div class="row d-flex align-items-stretch gx-2">
          @if (dischargeStatus() && dischargeStatus().taskStatus !== 'DISABLED') {
            <app-status-indicator class="col-12" [messageStatus]="dischargeStatus().taskStatus"
                                  [messageStatuses]="dischargeStatuses()"
                                  [customCssClass]="dischargeStatus().customCssClass"
                                  [showTooltip]="false">
              <span>{{ dischargeStatus().customLabel }}</span>
            </app-status-indicator>
          }
          @if (dischargeListStatus()) {
            <app-status-indicator class="col-12" [messageStatus]="dischargeListStatus().taskStatus"
                                  [messageStatuses]="dischargeListStatus()"
                                  [customCssClass]="dischargeListStatus().customCssClass"
                                  [showTooltip]="false">
              <span>{{ dischargeListStatus().customLabel }}</span>
            </app-status-indicator>
          } @else {
            <span>&nbsp;</span>
          }
        </div>
      </div>
      <div class="col-auto d-none d-xl-flex flex-column align-items-start justify-content-center text-truncate" [style.width.px]="70">
        @if (container().consignmentDataSummaries?.length) {
          <span class="d-inline-block text-truncate mw-100 text-end underline-tertiary link-underline-tertiary link-primary text-body cursor-pointer"
                (click)="collapsed.set(!collapsed())"
                [ngClass]="collapsible() ? '' : 'invisible'"
                data-bs-toggle="collapse"
                [attr.data-bs-target]="'#'+validSelector(container().containerNumber)"
                [attr.aria-controls]="validSelector(container().containerNumber)"
                aria-expanded="false">
              <i class="fa fa-fw fa-light fa-file-lines me-1 text-muted"></i>
              <span>{{ container().consignmentDataSummaries?.length | numberFormat }}</span>
          </span>
        } @else {
          <span>&nbsp;</span>
        }
        <span>&nbsp;</span>
      </div>
      <div class="col-auto d-flex flex-row align-items-center dropdown px-2">
        <button class="btn rounded-circle p-2 text-primary h1 m-0 action-btn-lg" type="button"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fa-light fa-fw fa-ellipsis-vertical"></i>
        </button>
        <div class="dropdown-menu position-fixed">
          @if (container().crn) {
            <a class="dropdown-item" [routerLink]="'/details/' + container().crn" target="_blank">
              <i class="fa-light fa-fw fa-right-to-bracket"></i>
              Open visit
            </a>
          }
          @if (selectable()) {
            <button class="btn dropdown-item" (click)="utils.createConsignment([container()])">
              <i class="fa-light fa-plus"></i>
              Add to new consignment
            </button>
            @if (container().overlanded) {
              <button class="btn dropdown-item" (click)="utils.refuseOverlandedContainers([container()])">
                <i class="fa-light fa-hand"></i>
                Refuse overlanded container
              </button>
            }
          }
          @if (appContext.isAdmin()) {
            <button class="btn dropdown-item" (click)="refreshSummary()">
              <i class="fa-light fa-arrows-rotate"></i>
              Refresh summary
            </button>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (collapsible() && container()) {
  <div class="collapse" [id]="validSelector(container().containerNumber)">
    @for (consignment of container().consignmentDataSummaries; track consignment) {
      <app-container-consignment-overview-item [consignment]="consignment" [term]="term()" [depth]="depth() + 1"
                                               [containerNumber]="container().containerNumber"
                                               [cargoDeclarantId]="container().cargoDeclarantId"
                                               [selectable]="selectable()" [collapsible]="false">
      </app-container-consignment-overview-item>
    }
  </div>
}
